// extracted by mini-css-extract-plugin
export default {"container":"Inspection_container__gHiNE","wrapper":"Inspection_wrapper__89J4Z"};